<div class="source-picker">
  @if (label) {
    <label class="source-picker__label">{{ label }}</label>
  }
  <sui-combobox
    [options]="options | comboboxOptions"
    [multiple]="true"
    [serverFilter]="true"
    [minTermLength]="0"
    (searchChange)="search$.next($event)"
    [loading]="loading"
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="disabled"
    [typeToSearchText]="
      'use-case-wizard.source-picker.type-to-search' | translate
    "
    (ngModelChange)="onSelect($event)"
  ></sui-combobox>
</div>
